import React from 'react';
import Error from 'layouts/Error';

/**
 * 404 Page Not Found Handler
 *
 * Custom 404 page that displays when a route is not found.
 * Uses the Error layout component with statusCode 404.
 *
 * @returns 404 error page component
 */
const NotFoundPage = (): React.JSX.Element => {
  return <Error statusCode={404} />;
};

export default NotFoundPage;
